import React from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';
import { getBudgetDisplayItems, type BudgetDetail } from '../../utils/budgetReceivable';

interface BudgetItemsInlineListProps {
  loading?: boolean;
  budgetDetail?: BudgetDetail | null;
  fallbackTotal?: number;
  formatCurrency: (value: number) => string;
}

const BudgetItemsInlineList: React.FC<BudgetItemsInlineListProps> = ({
  loading,
  budgetDetail,
  fallbackTotal = 0,
  formatCurrency,
}) => {
  if (loading) {
    return (
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75, mt: 0.5 }}>
        <CircularProgress size={12} sx={{ color: '#10b981' }} />
        <Typography variant="caption" color="text.secondary">Carregando itens...</Typography>
      </Box>
    );
  }

  const items = getBudgetDisplayItems(budgetDetail, fallbackTotal);
  if (!items.length) return null;

  return (
    <Box sx={{ mt: 0.5, display: 'flex', flexDirection: 'column', gap: 0.35 }}>
      {items.map((item, idx) => {
        const qty = item.quantity ?? 1;
        const sessions = Math.max(1, Number(item.estimated_sessions) || 1);
        return (
          <Typography
            key={item.id || idx}
            variant="caption"
            sx={{ color: '#475569', display: 'block', lineHeight: 1.45 }}
          >
            {item.procedure_name}
            {qty > 1 ? ` × ${qty}` : ''}
            {sessions > 1 ? ` · ${sessions} sessões pagas` : ''}
            {(item.tooth_number || item.tooth_region) && (
              <Box component="span" sx={{ color: '#94a3b8' }}>
                {' '}
                ({[item.tooth_number, item.tooth_region].filter(Boolean).join(' · ')})
              </Box>
            )}
            {' · '}
            <Box component="span" sx={{ fontWeight: 700, color: '#166534' }}>
              {formatCurrency(item.total || 0)}
            </Box>
          </Typography>
        );
      })}
    </Box>
  );
};

export default BudgetItemsInlineList;
